import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subscription: null,
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    fetchSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.subscription = action.payload;
    },
    fetchSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.subscription = null;
    },
  },
});

export const selectSubscription = (state) =>
  state.subscription?.subscription ?? null;

export const {
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
